import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { UrgencyBlock } from '../UrgencyBlock';
import { HERO_MOCKUP, heroStats } from '../../data/content';
export function Hero() {
  return <section className="bg-ink px-4 pb-12 pt-8 sm:px-6 sm:pt-12" data-id="element-142" data-mp="cuji64m195wj">
      <div className="mx-auto w-full max-w-3xl" data-id="element-143" data-mp="hvz4s13uzkh1">
        <div className="flex items-center justify-center gap-2" data-id="element-144" data-mp="hsl1mqndf78j">
          <ShieldCheckIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-145" data-mp="mt8znwa0ooc9" />
          <span className="text-[12px] font-bold uppercase tracking-[0.2em] text-cream/80" data-id="element-146" data-mp="quualc2zqsjt">
            Protocollo Clinico Sicuro™
          </span>
        </div>

        <h1 className="mt-6 text-center font-display text-[30px] font-bold leading-[1.12] text-cream sm:text-5xl" data-id="element-147" data-mp="10lfixr8gvbfx">
          Diagnostica riabilitazioni complesse in{' '}
          <span className="italic text-gold" data-id="element-148" data-mp="15md0c1lnk1gd">meno di 15 minuti</span>
        </h1>

        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-cream/70 sm:text-lg" data-id="element-149" data-mp="1akejsnmzq2sd">
          Un protocollo clinico passo dopo passo che riduce l’incertezza e ti
          aiuta a prendere decisioni con maggiore sicurezza. Include{' '}
          <span className="font-semibold text-cream" data-id="element-150" data-mp="3vuhh51ugj5qx">
            6 tomi, 5 strumenti professionali e oltre 30 protocolli e checklist.
          </span>
        </p>

        <div className="mt-7" data-id="element-151" data-mp="3rvihnwrhw16v">
          <img src={HERO_MOCKUP} alt="I 6 tomi del sistema Protocollo Clinico Sicuro" className="mx-auto w-full max-w-[520px]" width={1080} height={1080} data-id="element-152" data-mp="se0v9tx8o5n0" />
        </div>

        <div className="mx-auto -mt-2 max-w-md" data-id="element-153" data-mp="in68mog2z411">
          <CTAButton id="hero-cta" label="Voglio il Protocollo Clinico Sicuro" note="Download immediato · Pagamento unico di USD $27 · Accesso a vita · Garanzia di 7 giorni" data-id="element-154" data-mp="en5lmfex1kid" />
        </div>

        <div className="mx-auto mt-7 max-w-md" data-id="element-155" data-mp="16d0l34whmqkr">
          <UrgencyBlock data-id="element-156" data-mp="16c8p3syzaqty" />
        </div>

        <div className="mt-8 flex items-center justify-center gap-2" data-id="element-157" data-mp="30lnqcu5g4hup">
          <span className="flex" aria-hidden="true" data-id="element-158" data-mp="35kqtua5s2g0k">
            {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" data-id="element-159" data-mp="2qw473ndtmlzb" />)}
          </span>
          <p className="text-[13px] font-medium text-cream/70" data-id="element-160" data-mp="2vuxk7ep74ayy">
            Più di 1.200 odontoiatri usano già il sistema
          </p>
        </div>

        <ul className="mt-6 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-ink-line bg-ink-line sm:grid-cols-4" data-id="element-161" data-mp="2htuvsvaqaokv">
          {heroStats.map(stat => <li key={stat.label} className="flex flex-col items-center justify-center bg-ink-soft px-2 py-4 text-center" data-id="element-162" data-mp="27y1hp7hd2n0z">
              <span className="font-display text-2xl font-bold text-gold sm:text-3xl" data-id="element-163" data-mp="65viwi1j9k47">
                {stat.value}
              </span>
              <span className="mt-1 text-[11px] font-medium leading-tight text-cream/60" data-id="element-164" data-mp="b3x170r4xfem">
                {stat.label}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}